import React from "react";

import { useTranslation } from "react-i18next";
import { FrontendUserInfo, OrganizationInfo } from "node-library/dist/portal";
import OrganizationRow from "./organizationRow";
import { Card, Divider } from "@mui/material";
import { NeutralColor } from "node-library/dist/colors";

interface Props {
	organizations: Array<OrganizationInfo>;
	user: FrontendUserInfo | undefined;
	deleteOrganization: (organization: OrganizationInfo) => void;
	goToEditOrganizationPage: (organization: OrganizationInfo) => void;
	goToViewOrganizationDetails: (organization: OrganizationInfo) => void;
	setDiscardOrganizationConfirmOpen: React.Dispatch<
		React.SetStateAction<boolean>
	>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewOrganizationsTableListView(props: Props) {
	const { t: translation } = useTranslation();

	const {
		organizations,
		deleteOrganization,
		goToEditOrganizationPage,
		goToViewOrganizationDetails,
		setDiscardOrganizationConfirmOpen,
		setProceedAction,
	} = props;

	const headerItems = [
		{
			title: translation("Name"),
		},
		{
			title: translation("CityAndProvinceOrState"),
		},
		{
			title: translation("Country"),
		},
		{
			title: translation("Users"),
		},
		{
			title: translation("Action"),
		},
	];

	const organizationRows: Array<React.ReactNode> = organizations
		? organizations.map((organization: OrganizationInfo, index: number) => {
				return (
					<OrganizationRow
						key={organization.organizationId}
						organization={organization}
						user={props.user}
						goToViewOrganizationDetails={() =>
							goToViewOrganizationDetails(organization)
						}
						deleteOrganization={() => {
							setProceedAction(() => () => deleteOrganization(organization));
							setDiscardOrganizationConfirmOpen(true);
						}}
					/>
				);
		  })
		: [];

	const headerRowItems: React.ReactNode = headerItems.map((item) => {
		return (
			<div key={item.title} style={{ display: "flex", gap: "10px" }}>
				<Divider orientation="vertical" flexItem></Divider>
				<div
					className="typography-body-01"
					style={{
						color: NeutralColor.NEUTRAL_GREY_500,
						display: "flex",
						alignItems: "center",
						gap: "5px",
					}}
				>
					{item.title}
				</div>
			</div>
		);
	});

	const organizationRowContainer: React.ReactNode = (
		<Card className="card-small-padding">{organizationRows}</Card>
	);

	return (
		<div>
			<div className=" organization-list-view-row organization-list-view-header">
				{headerRowItems}
			</div>
			{organizationRowContainer}
		</div>
	);
}
